import { getFilteredOptions } from "helpers";
import { AgentOfficePartnerTypes } from "types";

const loadOptions = async search => {
	let options = await AgentOfficePartnerTypes.getOptions();

	const filteredOptions = getFilteredOptions(search, options);

	return {
		options: filteredOptions,
		hasMore: false,
	};
};

const partnerTypeAgentOfficeColumn = () => ({
	name: "partnerType",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Partner Type",
});

export default partnerTypeAgentOfficeColumn;
